module.exports = __webpack_public_path__ + "static/media/misc_icon.3c574152.svg";